import type { FingeringMode } from './fingering';

export const OMFZ_EXTENSION = '.omfz';
export const OMFZ_MIME_TYPE = 'application/zip';
export const ARCHIVE_SCHEMA_VERSION = '1.0.0';
export const ARCHIVE_MAX_UNCOMPRESSED_BYTES = 50 * 1024 * 1024;

export type ArchiveFileKey =
  | 'fingered_pdf'
  | 'audio_mp3'
  | 'fingering_json'
  | 'original_pdf'
  | 'score_mxl';

export interface ArchiveFileEntry {
  path: string;
  size: number;
  sha256: string;
  required: boolean;
}

/**
 * issue #66: 保存物の作成起源を識別する type。
 * - 'manual': ユーザが「保存」ボタンで Drive に保存した
 * - 'auto': バックエンドが長時間処理 (#65) 後に自動保存した
 */
export type ArchiveCreatedBy = 'manual' | 'auto';

export interface ArchiveManifest {
  schema_version: string;
  app: {
    name: string;
    version: string;
    source: string;
  };
  project: {
    title: string;
    part: string;
    tuning?: string;
    detected_bpm?: number;
    saved_at: string;
    saved_by_device: 'desktop' | 'mobile';
    /**
     * issue #66: 保存物の作成起源を識別 (optional、 後方互換)。
     * - undefined: 古い .omfz (#66 plan 適用前)、 'manual' として扱う
     */
    created_by?: ArchiveCreatedBy;
    /**
     * issue #81: 譜面モード (optional、 後方互換)。
     * - undefined: 古い .omfz (#81 適用前)、 復元時は stored.mode=undefined
     */
    mode?: FingeringMode;
  };
  files: Partial<Record<ArchiveFileKey, ArchiveFileEntry>>;
  compatibility: {
    min_app_version: string;
    fingering_schema_version: string;
  };
  description: string;
}

export type ArchiveErrorCode =
  | 'oversize'
  | 'missing_manifest'
  | 'invalid_manifest'
  | 'unsupported_schema'
  | 'checksum_mismatch'
  | 'not_authorized'
  | 'network'
  | 'quota_exceeded'
  | 'unknown';

export class ArchiveError extends Error {
  constructor(public code: ArchiveErrorCode, message: string, public cause?: unknown) {
    super(message);
    this.name = 'ArchiveError';
  }
}
